var _defs, _defs2, _defs3, _defs4, _defs5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWavyTech(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M3003.15,2643.634c-577.611,738.83-1930.312,750.692-2304.781,340.299 c-149.455-163.769-188.915-445.045-246.921-858.206c-27.924-198.888-31.922-359.206-34.293-469.2 c-8.176-374.16-12.245-561.258,47.988-688.542c172.529-364.347,771.871-506.153,1159.259-512.731 c27.037-0.467,54.323-0.288,81.822,0.539c453.602,13.516,965.458,202.339,1281.142,605.831 c32.631,41.625,63.102,85.551,91.238,131.813C3366.755,1667.274,3318.269,2240.609,3003.15,2643.634z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1897.608,2057.076c79.096-55.853,93.241-202.167,73.874-300.359 c-22.611-114.641-81.827-117.678-92.474-208.204c-19.824-168.548,177.316-227.142,170.804-398.701 c-5.323-140.248-139.095-154.308-137.922-309.89c0.845-112.265,70.905-158.905,39.438-256.865 c-2.69-8.375-32.996-98.272-109.773-119.283c-77.492-21.206-157.003,40.168-196.322,89.603 c-72.681,91.38-18.879,155.605-65.287,295.55c-63.183,190.528-200.31,184.262-217.836,334.169 c-14.473,123.789,75.695,156.614,56.922,293.549c-17.433,127.157-101.518,145.059-105.049,231.729 C1305.859,1907.759,1736.275,2171.001,1897.608,2057.076z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#D8DEE8"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000088097298035045991770000009371756000635504054_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000088097298035045991770000009371756000635504054_)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1783.547,2150.735c-0.467,0-0.942-0.121-1.374-0.375 c-74.244-43.609-136.11-100.84-183.878-170.103c-45.31-65.702-92.154-133.629-88.375-218.585 c2.875-64.641,32.951-99.172,71.029-142.89c36.304-41.683,81.488-93.559,113.099-189.638 c18.044-54.841,40.502-123.093,23.187-204.804c-10.048-47.423-28.605-74.259-44.978-97.936 c-17.146-24.796-31.955-46.212-29.125-82.951c4.532-58.853,35.964-96.439,72.36-139.961 c22.072-26.394,44.895-53.686,64.909-89.13c56.263-99.644,57.755-233.79,4.437-398.712c-0.462-1.429,0.323-2.962,1.751-3.424 c1.431-0.464,2.963,0.323,3.425,1.751c53.805,166.428,52.165,302.037-4.878,403.059 c-20.259,35.878-43.244,63.364-65.472,89.945c-35.796,42.805-66.71,79.773-71.109,136.89 c-2.681,34.814,10.935,54.507,28.176,79.439c16.664,24.098,35.551,51.411,45.826,99.902 c17.616,83.145-5.094,152.169-23.343,207.631c-31.954,97.123-77.538,149.458-114.165,191.51 c-37.38,42.918-66.906,76.817-69.696,139.56c-3.698,83.131,42.618,150.293,87.411,215.245 c47.322,68.615,108.607,125.307,182.162,168.511c1.296,0.761,1.729,2.427,0.968,3.722 C1785.388,2150.254,1784.479,2150.735,1783.547,2150.735z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1725.44,1265.908c-0.748,0-1.493-0.306-2.029-0.908c-1.001-1.12-0.904-2.839,0.215-3.84 c125.812-112.418,184.926-216.713,212.361-284.411c29.712-73.316,29.698-120.676,29.694-121.146 c-0.012-1.502,1.197-2.729,2.697-2.742c0.008,0,0.016,0,0.023,0c1.491,0,2.706,1.201,2.72,2.695 c0.017,1.952,0.073,48.654-29.949,122.882c-27.63,68.315-87.171,173.521-213.92,286.776 C1726.732,1265.68,1726.084,1265.908,1725.44,1265.908z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1664.917,1508.972c-0.606,0-1.214-0.2-1.72-0.613 c-70.229-57.378-123.626-122.461-158.71-193.444c-28.086-56.824-44.559-117.521-48.958-180.404 c-7.495-107.082,23.127-184.519,23.437-185.289c0.563-1.394,2.146-2.066,3.539-1.506c1.393,0.561,2.068,2.146,1.507,3.538 c-0.307,0.76-30.506,77.236-23.04,183.131c6.885,97.654,48.156,241.074,205.667,369.761c1.163,0.95,1.336,2.664,0.385,3.827 C1666.487,1508.631,1665.704,1508.972,1664.917,1508.972z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1549.98,1910.558c-1.177,0-2.26-0.769-2.608-1.955c-0.424-1.441,0.402-2.952,1.843-3.375 c185.51-54.426,282.249-153.318,330.736-226.694c52.458-79.385,61.24-146.609,61.322-147.279 c0.185-1.491,1.556-2.55,3.033-2.367c1.49,0.184,2.55,1.541,2.366,3.032c-0.085,0.683-9.03,69.175-62.184,149.613 c-48.987,74.133-146.654,174.024-333.741,228.913C1550.491,1910.523,1550.234,1910.558,1549.98,1910.558z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1788.978,799.538c-0.734,0-1.464-0.294-2.001-0.876 c-106.102-115.054-119.023-235.105-111.179-315.556c8.497-87.137,42.586-147.951,42.929-148.555 c0.744-1.306,2.406-1.762,3.708-1.021c1.307,0.742,1.764,2.402,1.023,3.708c-0.339,0.596-33.924,60.576-42.267,146.62 c-7.687,79.285,5.12,197.62,109.786,311.116c1.017,1.104,0.948,2.825-0.157,3.843 C1790.298,799.299,1789.637,799.538,1788.978,799.538z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000080915268224475308630000010533970001347111084_",
    d: "M1589.863,2559.057 c20.087,2.848,66.299-8.663,77.109-16.63c71.934-53.022,213.063-143.546,232.81-235.928 c3.372-15.777-62.032-49.349-67.82-66.283c-36.504-31.525-51.123-40.197-71.103-87.217 c-58.988-138.812,206.26-295.632-12.93-437.026c-160.553-103.568-325.715-84.012-231.469-351.629 c94.245-267.618,15.178-824.537-325.474-713.771c-195.503,63.569-91.724,341.933-224.055,489.577 c-125.748,140.3-93.779,293.219,52.033,438.52c145.811,145.301,32.805,194.846-60.078,335.525 c-111.573,168.986,164.914,280.734,296.961,321.438C1362.182,2268.408,1610.834,2423.609,1589.863,2559.057z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180368824894500748860000014892257612271927441_",
    gradientUnits: "userSpaceOnUse",
    x1: 1275.9806,
    y1: 1033.5503,
    x2: 1391.9015,
    y2: 1956.4569
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0036,
    style: {
      stopColor: "#E38DDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9571F6"
    }
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080915268224475308630000010533970001347111084_",
    style: {
      overflow: "visible",
      fill: "url(#SVGID_00000180368824894500748860000014892257612271927441_)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000121280725051046858730000017616476845969770630_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000080915268224475308630000010533970001347111084_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7,
      clipPath: "url(#SVGID_00000121280725051046858730000017616476845969770630_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1778.789,2431.625l2.852-3.235c-498.332-439.618-681.837-1127.26-490.875-1839.438 l-4.168-1.119c-90.501,337.522-96.739,682.7-18.037,998.215C1351.298,1917.755,1527.733,2210.149,1778.789,2431.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M904.455,1979.111c181.554-8.65,460.406,66.747,621.606,168.077l2.295-3.653 c-161.834-101.726-441.806-177.418-624.105-168.734L904.455,1979.111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1681.953,2344.207l3.638-2.32c-53.166-83.478-62.087-190.627-26.515-318.469 c26.082-93.74,75.034-196.216,145.5-304.588l-3.619-2.351c-70.703,108.739-119.84,211.618-146.038,305.781 C1619.004,2151.332,1628.099,2259.65,1681.953,2344.207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1259.13,1540.831l3.754-2.128c-92.122-162.505-268.974-248.005-401.113-291.117l-1.338,4.104 C991.847,1294.564,1167.692,1379.53,1259.13,1540.831z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1213.133,1115.698l4.232,0.844c41.2-206.368,206.843-352.508,301.913-421.253l-2.528-3.498 C1421.167,760.909,1254.621,907.885,1213.133,1115.698z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016058548462847422890000001707217067453732237_",
    gradientUnits: "userSpaceOnUse",
    x1: 1937.4299,
    y1: 3131.1707,
    x2: 1772.0225,
    y2: 3200.6418
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016058548462847422890000001707217067453732237_)"
    },
    d: "M3297.472,3040.659l-2354.628-20.507 v60.677c0,16.469,10.27,30.473,24.179,32.969l665.819,119.485c7.902,1.418,15.915,1.794,23.889,1.122l1615.155-136.232 c14.42-1.216,25.587-15.263,25.587-32.184V3040.659z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000936643677778510800000005643713352543739053_",
    gradientUnits: "userSpaceOnUse",
    x1: 1716.5604,
    y1: 2402.1641,
    x2: 1537.0505,
    y2: 2477.5581
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000936643677778510800000005643713352543739053_)"
    },
    d: "M2539.487,2942.299L968.759,3053.301 c-28.107,1.986-50.96-19.12-50.96-47.147V1883.269c0-28.027,22.853-50.748,50.96-50.748h1570.729 c23.156,0,41.878,20.539,41.878,45.876v1015.067C2581.365,2918.799,2562.643,2940.662,2539.487,2942.299z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114752333943301648120000004851225913903292050_",
    gradientUnits: "userSpaceOnUse",
    x1: 942.8437,
    y1: 2442.9753,
    x2: 2606.4106,
    y2: 2442.9753
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114752333943301648120000004851225913903292050_)"
    },
    d: "M2564.532,2942.299L993.804,3053.301 c-28.108,1.986-50.961-19.12-50.961-47.147V1883.269c0-28.027,22.853-50.748,50.961-50.748h1570.728 c23.157,0,41.878,20.539,41.878,45.876v1015.067C2606.411,2918.799,2587.689,2940.662,2564.532,2942.299z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116954500201440874450000017384513138262384000_",
    gradientUnits: "userSpaceOnUse",
    x1: 1993.7588,
    y1: 2039.7634,
    x2: 718.7945,
    y2: 4124.0537
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116954500201440874450000017384513138262384000_)"
    },
    d: "M2515.599,2870.734l-1462.969,96.42 c-22.874,1.507-41.461-15.816-41.461-38.697v-983.086c0-22.881,18.587-41.507,41.461-41.601l1462.969-6.054 c19.103-0.08,34.554,16.751,34.554,37.591v895.416C2550.153,2851.563,2534.702,2869.476,2515.599,2870.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1834.642,1863.234c0,10.434-8.084,18.916-18.068,18.946 c-9.996,0.031-18.107-8.422-18.107-18.879c0-10.457,8.112-18.94,18.107-18.947 C1826.558,1844.347,1834.642,1852.8,1834.642,1863.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.48,
      fill: "#FFFFFF"
    },
    d: "M2186.09,2634.33c-121.089-65.152-216.301,17.403-308.187-64.05 c-55.708-49.382-28.358-86.207-96.905-160.003c-75.921-81.735-125.35-54.26-201.648-127.822 c-96.475-93.015-48.224-165.382-131.325-232.164c-100.813-81.016-209.536-6.031-305.503-83.727 c-41.391-33.511-64.102-82.23-75.962-134.043h-93.899c-16.455,0-29.817,13.336-29.817,29.788v1163.967 c0,16.451,13.362,28.839,29.817,27.671l1600.829-113.63c7.856-0.557,14.822-5.144,19.293-11.794 c-117.185-4.271-189.178-43.555-235.198-84.166C2267.558,2764.91,2283.173,2686.564,2186.09,2634.33z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039123616703991815190000009726244634826371201_",
    gradientUnits: "userSpaceOnUse",
    x1: 942.8437,
    y1: 3058.1563,
    x2: 3297.4719,
    y2: 3058.1563
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039123616703991815190000009726244634826371201_)"
    },
    d: "M2525.34,2937.264l-1582.496,116.84 l689.997,123.823c7.902,1.418,15.915,1.794,23.889,1.122l1640.742-138.39l-746.959-102.601 C2542.159,2936.911,2533.734,2936.645,2525.34,2937.264z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163069616133711420750000003789962729715313034_",
    gradientUnits: "userSpaceOnUse",
    x1: 1173.7545,
    y1: 3038.8635,
    x2: 2898.9761,
    y2: 3038.8635
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000163069616133711420750000003789962729715313034_)"
    },
    points: " 1173.755,3057.042 2491.229,2958.32 2898.976,3013.876 1592.851,3119.407  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2792.971,1518.422l-1230.145-30.564c-34.762-0.864-63.061,28.257-63.061,65.048v249.379 c0,36.79,28.298,66.606,63.061,66.595l1230.145-0.387c29.216-0.009,52.81-27.201,52.81-60.735v-227.305 C2845.781,1546.918,2822.187,1519.147,2792.971,1518.422z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2443.22,1625.083 1619.449,1611.278 1619.449,1570.607 2443.22,1586.633  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2443.22,1689.167 1619.449,1679.063 1619.449,1638.392 2443.22,1650.717  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "2081.442,1750.44 1619.449,1746.849 1619.449,1706.177 2081.442,1711.014  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065793044317324209800000012117599770724130730_",
    gradientUnits: "userSpaceOnUse",
    x1: 2533.5127,
    y1: 1686.8751,
    x2: 2988.9338,
    y2: 1686.8751
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065793044317324209800000012117599770724130730_)"
    },
    d: "M2988.934,1689.77 c0,141.948-99.389,257.618-223.992,258.369c-126.872,0.764-231.429-117.497-231.429-264.157s104.557-262.264,231.429-258.274 C2889.545,1429.626,2988.934,1547.823,2988.934,1689.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2964.039,1689.454c0,126.171-88.431,228.799-199.098,229.233 c-112.452,0.44-204.951-104.487-204.951-234.368c0-129.881,92.5-232.457,204.951-229.158 C2875.608,1458.406,2964.039,1563.282,2964.039,1689.454z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122721821955554269870000001196058465976206221_",
    gradientUnits: "userSpaceOnUse",
    x1: 1470.2791,
    y1: 2666.2644,
    x2: 2816.2947,
    y2: 2666.2644
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122721821955554269870000001196058465976206221_)"
    },
    d: "M2763.485,2449.813l-1230.145,51.784 c-34.763,1.463-63.061,32.479-63.061,69.27v249.38c0,36.79,28.298,64.712,63.061,62.374l1230.145-82.735 c29.216-1.965,52.81-30.736,52.81-64.271v-227.305C2816.295,2474.775,2792.701,2448.584,2763.485,2449.813z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2413.734,2579.888 1589.962,2621.227 1589.962,2580.556 2413.734,2541.438  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2413.734,2643.972 1589.962,2689.013 1589.962,2648.342 2413.734,2605.522  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2051.956,2729.463 1589.962,2756.798 1589.962,2716.127 2051.956,2690.037  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004509318495044778700000002571690407837141439_",
    gradientUnits: "userSpaceOnUse",
    x1: 2504.0259,
    y1: 2620.3975,
    x2: 2959.4473,
    y2: 2620.3975
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000004509318495044778700000002571690407837141439_)"
    },
    d: "M2959.447,2608.044 c0,141.947-99.388,264.271-223.992,273.363c-126.872,9.257-231.429-102.005-231.429-248.665 c0-146.66,104.557-269.263,231.429-273.766C2860.059,2354.553,2959.447,2466.097,2959.447,2608.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2934.552,2609.394c0,126.171-88.431,234.719-199.098,242.561 c-112.451,7.968-204.951-90.768-204.951-220.648c0-129.881,92.5-238.649,204.951-242.878 C2846.121,2384.267,2934.552,2483.223,2934.552,2609.394z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M932.445,2000.164l1330.193-11.473c31.483-0.272,56.904,27.726,56.904,62.533v235.936 c0,34.807-25.421,63.883-56.904,64.947l-1330.193,44.941c-37.721,1.274-68.432-28.76-68.432-67.088v-259.805 C864.013,2031.826,894.724,2000.49,932.445,2000.164z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1359.104,2120.604 2210.749,2106.371 2210.749,2067.293 1359.104,2079.231  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1359.104,2189.559 2210.749,2171.5 2210.749,2132.422 1359.104,2148.186  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D8DEE8"
    },
    points: "1757.015,2248.288 2210.749,2236.628 2210.749,2197.551 1757.015,2207.988  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173142578061297620500000012990700202606217376_",
    gradientUnits: "userSpaceOnUse",
    x1: -1950.3051,
    y1: 2190.9712,
    x2: -1369.8993,
    y2: 2190.9712,
    gradientTransform: "matrix(-1 0 0 1 -697.1331 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173142578061297620500000012990700202606217376_)"
    },
    d: "M672.766,2196.994 c0,165.915,133.684,295.135,295.552,288.742c158.605-6.264,284.853-140.883,284.853-300.792s-126.248-289.285-284.853-288.964 C806.45,1896.307,672.766,2031.079,672.766,2196.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M706.644,2196.291c0,146.896,118.223,261.56,261.674,256.197 c140.882-5.267,253.253-124.719,253.253-266.888s-112.37-256.955-253.253-256.372 C824.868,1929.821,706.644,2049.394,706.644,2196.291z"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000076590119858048450100000013821637564947769984_",
    d: "M1377.821,1448.296l-33.919-604.517l-931.374,225.383 v929.556l300.401,254.844c26.202,118.401,131.354,203.563,255.389,198.926c122.112-4.565,222.703-94.898,247.363-211.168 l178.622-4.349L1377.821,1448.296z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161608793686392893350000002606670137355480241_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000076590119858048450100000013821637564947769984_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000161608793686392893350000002606670137355480241_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049920219521038087350000006221937419973690799_",
    gradientUnits: "userSpaceOnUse",
    x1: 885.268,
    y1: 1049.4249,
    x2: 890.6821,
    y2: 1547.4901
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049920219521038087350000006221937419973690799_)"
    },
    d: "M946.455,1854.991 c-54.025,33.257-119.763,24.429-249.031,5.413c-124.843-18.364-187.264-27.546-220.112-66.857 c-59.291-70.96-42.48-197.823,5.278-281.041c69.346-120.836,175.422-99.961,222.955-212.425 c42.742-101.132-27.526-154.707,16.241-227.378c62.871-104.391,282.458-117.669,435.806-40.603 c73.869,37.123,194.407,126.387,181.362,213.843c-11.695,78.414-127.696,134.703-251.739,194.895 c-102.509,49.743-163.376,60.419-189.483,121.809c-23.951,56.322-6.465,126.682,10.829,129.93 c12.084,2.27,18.026-29.359,48.724-40.603c26.602-9.743,64.11-1.362,78.498,18.948 C1063.229,1709.672,1019.434,1810.067,946.455,1854.991z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021834956684733762530000004173146257886606467_",
    gradientUnits: "userSpaceOnUse",
    x1: -1321.3053,
    y1: 1842.8607,
    x2: -1396.5413,
    y2: 2115.8096,
    gradientTransform: "matrix(-1 0 0 1 -115.3658 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021834956684733762530000004173146257886606467_)"
    },
    d: "M1197.628,1503.967 c0,0,180.946,78.906,150.519,280.753c-30.548,202.65-303.38,140.072-303.38,140.072l-16.323-141.724 c0,0,208.67,10,182.686-121.27c-28.387-143.407-52.676-145.482-52.676-145.482L1197.628,1503.967z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057148522176088198810000005128277117823464341_",
    gradientUnits: "userSpaceOnUse",
    x1: -1113.4034,
    y1: 3040.1252,
    x2: -1095.9974,
    y2: 3353.4373,
    gradientTransform: "matrix(-1 0 0 1 -115.3658 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057148522176088198810000005128277117823464341_)"
    },
    d: "M951.964,3151.396 c0,0-2.342,19.118-0.77,25.328c1.575,6.209,55.567,6.254,73.811,2.526c18.201-3.716-10.862-20.285-22.497-22.893 C990.857,3153.745,951.964,3151.396,951.964,3151.396z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059292059539393042430000007129883243813419962_",
    gradientUnits: "userSpaceOnUse",
    x1: -1078.8046,
    y1: 3198.1855,
    x2: -1089.0215,
    y2: 2730.7708,
    gradientTransform: "matrix(-1 0 0 1 -115.3658 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059292059539393042430000007129883243813419962_)"
    },
    d: "M979.193,3117.658l-5.693,38.368 c0,0-14.537,7.837-21.536,1.847l-0.77-39.679L979.193,3117.658z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062167654556764320580000012332934541612024506_",
    gradientUnits: "userSpaceOnUse",
    x1: -769.9044,
    y1: 3028.0754,
    x2: -749.8186,
    y2: 3389.623,
    gradientTransform: "matrix(-1 0 0 1 -115.3658 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062167654556764320580000012332934541612024506_)"
    },
    d: "M668.78,3140.673 c0,0,11.906,7.865,8.733,18.674c-3.173,10.814-31.003,55.458-50.896,69.174c-19.941,13.75-13.685-11.896-7.881-28.018 c5.799-16.111,20.601-51.72,26.37-57.946C650.872,3136.339,668.78,3140.673,668.78,3140.673z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180353444035525525800000000112341142982456994_",
    gradientUnits: "userSpaceOnUse",
    x1: -774.9703,
    y1: 3219.6853,
    x2: -785.7531,
    y2: 2726.3826,
    gradientTransform: "matrix(-1 0 0 1 -115.3658 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180353444035525525800000000112341142982456994_)"
    },
    d: "M690.183,3096.567 c-5.745,16.439-11.278,30.027-15.606,40.075c-9.585,22.249-14.828,30.738-20.771,38.216 c-5.187,6.518-17.477,20.541-20.784,18.648c-3.361-1.919,5.642-18.484,22.961-66.185c2.514-6.913,10.444-28.925,10.444-28.925 l0,0L690.183,3096.567z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152249454926444869010000011951108809596466086_",
    gradientUnits: "userSpaceOnUse",
    x1: -1224.244,
    y1: 2896.0615,
    x2: -1033.2109,
    y2: 2639.6746,
    gradientTransform: "matrix(-1 0 0 1 -115.3658 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152249454926444869010000011951108809596466086_)"
    },
    d: "M1091.469,2414.214 c3.894,39.042,7.629,99.696,2.044,173.739c-7.285,96.548-26.092,158.49-49.741,262.687 c-14.49,63.832-34.055,157.865-51.803,275.253c-4.123,2.733-16.267,10.034-31.931,8.938 c-8.783-0.617-15.359-3.635-19.245-5.875c-47.062-142.143-33.133-233.477-10.426-291.166 c9.658-24.541,21.353-44.12,27.597-81.253c8.255-49.083-1.953-75.731-16.532-187.762c-10.409-79.978-8.606-92.482-1.68-104.808 C967.372,2414.794,1051.261,2412.794,1091.469,2414.214z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096020115879748059470000006322312176574060416_",
    gradientUnits: "userSpaceOnUse",
    x1: -1088.8826,
    y1: 2947.5073,
    x2: -628.4954,
    y2: 2518.158,
    gradientTransform: "matrix(-1 0 0 1 -115.3658 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096020115879748059470000006322312176574060416_)"
    },
    d: "M931.41,2436.782 c-28.831,152.036-57.231,232.783-78.791,278.876c-5.325,11.385-23.122,48.208-39.981,100.619 c-14.955,46.485-21.196,80.427-24.395,95.404c-10.109,47.312-35.148,117.25-102.917,212.051 c-0.848,0.566-12.463,8.038-23.582,3.066c-5.633-2.521-8.442-7.025-9.56-9.14c8.93-86.734,19.168-159.731,28.042-216.067 c1.864-11.808,10.054-63.442,22.882-131.69c5.015-26.68,12.357-65.74,21.144-105.885 c10.925-49.931,27.651-117.83,53.361-199.219C829.211,2455.396,880.476,2446.061,931.41,2436.782z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021118790925364542030000006604243711202758547_",
    gradientUnits: "userSpaceOnUse",
    x1: -1199.8225,
    y1: 2914.2607,
    x2: -1008.7933,
    y2: 2657.8792,
    gradientTransform: "matrix(-1 0 0 1 -115.3658 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000021118790925364542030000006604243711202758547_)"
    },
    d: "M930.367,2837.789 c9.658-24.541,21.353-44.122,27.597-81.253c8.255-49.083-1.953-75.731-16.532-187.762 c-10.409-79.978-8.606-92.482-1.68-104.808c15.023-26.743,46.764-39.488,79.026-45.362c-0.43,1.698-0.864,3.4-1.214,5.042 c-16.914,79.361,47.44,124.601,18.478,212.247c-14.317,43.332-37.219,54.3-42.564,104.117 c-5.011,46.695,13.147,55.288,9.272,97.667c-5.796,63.389-49.89,81.597-61.405,130.807 c-7.49,32.015-1.181,77.588,53.323,139.895c-0.903,5.792-1.803,11.602-2.698,17.512c-4.125,2.733-16.267,10.034-31.931,8.938 c-8.783-0.617-15.359-3.635-19.245-5.875C893.731,2986.812,907.66,2895.478,930.367,2837.789z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163033773198695360890000014529430171331433905_",
    gradientUnits: "userSpaceOnUse",
    x1: -1164.1875,
    y1: 2048.4053,
    x2: -729.5839,
    y2: 2618.8235,
    gradientTransform: "matrix(-1 0 0 1 -115.3658 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163033773198695360890000014529430171331433905_)"
    },
    d: "M1150.119,1829.736 c-4.19-6.702-17.525-25.297-74.374-39.244c-28.648-7.027-81.891-19.151-150.943-4.662 c-95.835,20.107-156.11,78.397-178.915,103.027c18.68,12.162,70.001,49.12,95.294,119.231 c7.854,21.768,31.01,96.078-2.128,166.554c-19.156,40.746-53.157,71.869-79.078,95.602 c-39.037,35.734-59.33,41.642-72.493,73.201c-14.36,34.425,0.109,50.522-17.727,74.39c-19.2,25.69-41.754,14.854-74.495,41.411 c-33.677,27.311-21.677,48.288-52.402,78.356c-44.854,43.89-104.701,32.841-107.496,51.945 c-2.408,16.438,40.198,36.594,76.222,43.846c70.869,14.265,132.179-18.196,150.321-28.123 c50.015-27.363,41.397-43.202,79.362-63.922c63.167-34.474,106.051-0.922,247.313-3.346 c75.453-1.292,113.33-2.485,134.004-29.259c18.833-24.394,8.939-49.919-2.372-161.271c0,0,0-0.004-0.001-0.013 c-3.638-37.228-11.261-115.23-11.307-159.804c-0.028-26.343,8.874-69.53,26.65-155.757 c1.048-5.08,10.649-51.576,18.398-113.583C1160.922,1862.533,1159.913,1845.409,1150.119,1829.736z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144304337810771807450000007725976855084534917_",
    gradientUnits: "userSpaceOnUse",
    x1: -911.0358,
    y1: 1776.13,
    x2: -797.581,
    y2: 2469.9519,
    gradientTransform: "matrix(-1 0 0 1 -115.3658 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144304337810771807450000007725976855084534917_)"
    },
    d: "M542.858,2537.602 c30.724-30.068,18.724-51.045,52.402-78.356c32.741-26.557,55.295-15.721,74.495-41.411 c17.836-23.868,3.367-39.965,17.727-74.39c13.163-31.559,33.455-37.465,72.493-73.202 c25.921-23.732,59.922-54.855,79.078-95.601c33.138-70.476,9.982-144.786,2.128-166.554 c-25.293-70.111-76.614-107.069-95.294-119.231c1.8-1.948,3.923-4.164,6.193-6.499 c122.173,16.695,192.548,87.009,201.206,107.807c19.983,47.985-11.674,66.061-12.493,205.215 c-0.39,66.52,6.677,92.591-14.6,120.95c-24.406,32.526-52.625,23.525-88.178,66.376 c-27.428,33.051-23.028,53.281-48.709,67.772c-27.706,15.631-45.404-0.749-76.84,7.123 c-52.796,13.219-64.127,74.578-99.271,109.447c-26.678,26.47-76.236,46.458-174.873,31.866 c-2.295-3.182-3.405-6.341-2.961-9.366C438.16,2570.443,498.004,2581.492,542.858,2537.602z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161616786290561250760000003477310916558959005_",
    gradientUnits: "userSpaceOnUse",
    x1: 997.1702,
    y1: 1663.1459,
    x2: 968.105,
    y2: 1821.6826
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161616786290561250760000003477310916558959005_)"
    },
    d: "M963.805,1710.728 c0,0-6.047,49.069-23.918,60.221c-17.913,11.168-46.956,25.782-50.162,29.778c-3.207,3.991,110.762,16.811,166.635-11.742l0,0 c-18.369-4.004-23.371-5.47-23.371-5.47c-4.996-1.467-14.324-4.197-23.686-9.689c-6.378-3.738-16.672-11.037-26.125-24.772 l0.207-27.157L963.805,1710.728z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152962881856159936920000014382715711873310088_",
    gradientUnits: "userSpaceOnUse",
    x1: 954.3867,
    y1: 1602.6708,
    x2: 969.4216,
    y2: 1686.6892
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152962881856159936920000014382715711873310088_)"
    },
    d: "M961.092,1728.098 c0,0,11.626,16.312,29.822,9.703c16.258-5.905,6.559-48.756-6.35-53.782c-4.311-1.679-12.232-1.049-17.532,2.251 c-3.73,2.322-13.698,14.794-7.982,28.949c-4.129-1.255-7.765-0.186-8.676,1.884c-1.158,2.625,2.343,6.246,3.134,7.066 C956.254,1727.011,959.566,1727.828,961.092,1728.098z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035524075598905537140000016854960681033457077_",
    gradientUnits: "userSpaceOnUse",
    x1: 1160.8317,
    y1: 1478.3378,
    x2: 1207.2722,
    y2: 1478.3378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035524075598905537140000016854960681033457077_)"
    },
    d: "M1169.087,1511.573l-8.058-25.279 c-1.123-3.524,2.8-6.367,5.649-4.073c7.03,5.663,4.646,19.061,34.245-33.369c11.819-20.934,4.727,26.877-1.864,40.314 c-4.477,9.128-4.109,13.964-8.077,16.896C1184.509,1510.846,1176.268,1515.515,1169.087,1511.573z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009588011808424120840000016297821940811036555_",
    gradientUnits: "userSpaceOnUse",
    x1: -993.8854,
    y1: 2001.7454,
    x2: -722.7937,
    y2: 2001.7454,
    gradientTransform: "matrix(-1 0 0 1 -115.3658 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009588011808424120840000016297821940811036555_)"
    },
    d: "M876.867,2034.219 c12.01,25.648-43.335,86.58-105.305,116.302c-12.685,6.086-104.381,50.06-145.589,10.152 c-34.211-33.134-12.115-103.214-4.242-128.187c38.552-122.273,155.798-184.15,204.426-206.23 c36.099,91.01,14.858,131.652,6.483,144.376c-8.76,13.306-33.256,41.361-59.354,66.197 c-18.41,17.516-29.896,26.087-28.351,28.77c1.923,3.34,23.52-3.282,106.854-45.032 C861.393,2022.043,872.758,2025.453,876.867,2034.219z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1078.633,1883.198l-143.879,13.969c-3.045,0.296-5.605,2.455-6.447,5.44l-54.418,192.789 c-1.445,5.121,2.621,10.037,7.846,9.491l146.022-15.246c3.042-0.318,5.599-2.522,6.419-5.534l52.153-191.488 C1087.702,1887.581,1083.719,1882.705,1078.633,1883.198z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096029577806484417080000010621799513200086201_",
    gradientUnits: "userSpaceOnUse",
    x1: -1180.3,
    y1: 2385.7866,
    x2: -1159.2682,
    y2: 2201.1726,
    gradientTransform: "matrix(-1 0 0 1 -115.3658 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000096029577806484417080000010621799513200086201_)"
    },
    d: "M983.161,2048.803 c5.441-30.298-11.337-53.602,4.742-82.077c16.506-29.231,45.402-24.459,66.091-48.477c6.575-7.632,12.47-18.426,15.365-34.15 l9.273-0.9c5.086-0.494,9.069,4.382,7.697,9.42l-52.153,191.488c-0.821,3.012-3.377,5.217-6.419,5.534l-73.813,7.707 C972.789,2079.892,980.565,2063.262,983.161,2048.803z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073698638466764912040000013560043596921748099_",
    gradientUnits: "userSpaceOnUse",
    x1: 855.7308,
    y1: 2005.2527,
    x2: 935.9196,
    y2: 2005.2527
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073698638466764912040000013560043596921748099_)"
    },
    d: "M855.968,2028.403 c0,0,50.346-52.514,70.744-60.328c20.345-7.796,2.334,47.074-9.607,54.918c-11.958,7.855-16.629,10.86-25.979,12.142 c-9.36,1.286-9.36,1.286-9.36,1.286l-12.303,6.765C869.463,2043.186,853.619,2041.47,855.968,2028.403z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005241909935223984430000000500356298532517790_",
    d: "M3211.649,1962.849H2051.956l106.521,638.509 l330.493-20.026l58.265,141.517c31.64,81.647,104.398,135.045,188.22,129.105c82.828-5.869,153.141-68.118,183.272-151.683 l249.172-15.143L3211.649,1962.849z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129203052512580693500000007950343178966656163_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005241909935223984430000000500356298532517790_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000129203052512580693500000007950343178966656163_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132076077308638930570000007690946456150076341_",
    gradientUnits: "userSpaceOnUse",
    x1: 2235.749,
    y1: 2481.5112,
    x2: 2205.1218,
    y2: 2766.166
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132076077308638930570000007690946456150076341_)"
    },
    d: "M2287.818,2125.403 c0,0,28.117-38.302,25.213-47.809c-2.905-9.511-44.664-21.135-54.409-41.326c-9.757-20.218-13.663,2.186,0,21.33 c13.638,19.109,13.638,19.109,13.638,19.109l16.528,8.895l-18.475,24.625L2287.818,2125.403z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062177991076527744930000018394750301085695370_",
    gradientUnits: "userSpaceOnUse",
    x1: 2752.9089,
    y1: -1043.5793,
    x2: 3077.7222,
    y2: -1794.0958,
    gradientTransform: "matrix(0.6817 -0.7316 -0.7316 -0.6817 -505.6033 3548.5254)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062177991076527744930000018394750301085695370_)"
    },
    d: "M2306.853,2121.448 c-13.802-15.368-27.09-21.433-39.248-22.191c-54.12-3.377-119.697,96.408-124.196,187.834 c-0.323,6.562-4.065,108.759,70.94,171.083c108.167,89.878,301.819,31.945,334.153-50.318 c10.623-27.027,7.652-65.944,7.135-72.73c-3.323-43.537-19.49-74.979-29.214-90.928 c-83.046,28.614-187.066,48.038-219.104,6.063C2283.364,2218.877,2273.402,2172.087,2306.853,2121.448z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150098800787327480780000002515357254299848365_",
    gradientUnits: "userSpaceOnUse",
    x1: -7921.3716,
    y1: 2995.7097,
    x2: -7594.0791,
    y2: 2239.4653,
    gradientTransform: "matrix(-0.9994 0.0353 0.0353 0.9994 -5166.0664 63.2228)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150098800787327480780000002515357254299848365_)"
    },
    d: "M2974.303,2233.535 c-66.089-18.849-167.794-37.919-292.984-23.324c-73.498,8.568-136.95,26.601-187.481,45.283 c-7.039,28.832-15.216,71.079-17.177,122.391c-8.662,226.717,112.48,409.62,103.487,414.019 c-6.621,3.239-51.95-105.882-73.225-99.901c-24.611,6.918-20.324,168.369,44.066,200.339 c18.848,9.358,25.188,7.376,118.556-13.405c61.958-13.792,87.991-17.938,119.484-10.437 c42.673,10.161,62.752,18.834,79.817,8.512c16.325-9.878,17.549-40.578,18.006-93.901 c0.707-82.251-1.096-137.916-1.389-157.88c-1.346-91.611,18.312-163.458,43.414-255.195 C2944.534,2312.818,2961.379,2266.271,2974.303,2233.535z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027584749457416331870000012996579688162247317_",
    gradientUnits: "userSpaceOnUse",
    x1: -5945.0186,
    y1: 5978.3359,
    x2: -5936.5034,
    y2: 5751.5229,
    gradientTransform: "matrix(-0.8781 0.4784 0.4784 0.8781 -5343.4131 -113.645)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027584749457416331870000012996579688162247317_)"
    },
    d: "M2686.987,2117.689 c1.68,23.261,5.622,41.376,8.963,53.695c3.826,14.107,6.046,17.593,8.739,20.306c4.052,4.082,9.943,7.183,42.069,11.344 c17.424,2.257,19.607,1.85,20.127,3.589c2.531,8.483-41.678,44.377-90.69,43.593c-30.157-0.482-58.819-14.792-57.904-24.408 c0.921-9.678,31.204-8.477,38.712-26.699c5.217-12.665-3.06-28.646-12.376-41.584 C2651.309,2140.933,2680.34,2134.229,2686.987,2117.689z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065753877996762519380000010212259886573263806_",
    gradientUnits: "userSpaceOnUse",
    x1: 8802.7998,
    y1: 3905.4763,
    x2: 8745.1328,
    y2: 3759.0122,
    gradientTransform: "matrix(0.9495 -0.3138 0.3138 0.9495 -6842.4497 1267.5063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065753877996762519380000010212259886573263806_)"
    },
    d: "M2627.336,2140.873 c-9.69-6.724-15.264-22.81-10.754-36.035c3.88-11.375,13.989-16.615,20.034-19.752c17.491-9.072,42.864-9.844,56.291,4.526 c7.944,8.504,4.536,33.76,4.159,38.211c-0.429,5.034-3.225,7.778-5.21,12.222c-2.75,6.166-7.023,15.933-13.911,32.18 c-1.966-3.255-4.636-7.194-8.17-11.22c-1.361-1.551-6.766-7.573-13.385-11.751 C2643.111,2140.863,2636.51,2147.238,2627.336,2140.873z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005989708900381727480000000822778785337556915_",
    gradientUnits: "userSpaceOnUse",
    x1: -7460.0684,
    y1: 3299.7002,
    x2: -7462.7798,
    y2: 3518.1533,
    gradientTransform: "matrix(-0.9669 0.2551 0.2551 0.9669 -5395.3232 842.1304)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005989708900381727480000000822778785337556915_)"
    },
    d: "M2690.012,2156.147 c0,0-5.455,24.917-29.678,32.473c-21.754,6.784-40.677-41.751-30.383-57.529c3.432-5.26,12.071-10.195,20.148-10.858 c4.766-0.39,6.841,0.933,14.614,0.133c7.163-0.734,8.784-2.208,11.326-1.223c3.178,1.235,6.693,5.89,7.125,21.981 c2.695-5.822,7.028-9.322,10.999-8.946c0.633,0.062,2.412,0.536,3.725,1.787 C2702.632,2138.488,2699.965,2147.615,2690.012,2156.147z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094615070580671934550000016426128661760204973_",
    gradientUnits: "userSpaceOnUse",
    x1: 8785.1445,
    y1: 3914.968,
    x2: 8725.7061,
    y2: 3764.0046,
    gradientTransform: "matrix(0.9495 -0.3138 0.3138 0.9495 -6842.4497 1267.5063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094615070580671934550000016426128661760204973_)"
    },
    d: "M2676.059,2115.809 c-0.771,1.187,3.615,3.973,5.629,9.52c3.91,10.758-2.549,27.953-13.032,33.231c-6.205,3.123-9.244-0.224-20.232,2.687 c-6.812,1.806-12.018,4.783-15.221,6.893c0.47,13.306,7.419,24.07,16.904,26.641c10.198,2.765,19.641-4.954,23.586-8.178 c2.637-2.156,11.09-9.039,13.174-19.998c2.17-11.417-4.687-15.158-0.791-23.813c1.965-4.363,5.44-7.259,7.282-14.951 c0.5-2.089,0.718-3.852,0.822-5.02C2686.806,2118.866,2677.177,2114.09,2676.059,2115.809z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164488624194185375500000011637930324395730367_",
    gradientUnits: "userSpaceOnUse",
    x1: 8727.9121,
    y1: 3826.1282,
    x2: 8730.7871,
    y2: 3851.7578,
    gradientTransform: "matrix(0.9495 -0.3138 0.3138 0.9495 -6842.4497 1267.5063)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164488624194185375500000011637930324395730367_)"
    },
    d: "M2642.36,2169.617 c0,0,5.395,0.731,13.195-2.792c0.378-0.171,0.842-0.218,0.957-0.028c0.431,0.713-3.55,6.19-8.683,6.625 c-3.648,0.307-7.288-1.978-7.104-2.987C2640.802,2170.01,2641.573,2169.766,2642.36,2169.617z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047040478001365095760000005267554140009490620_",
    gradientUnits: "userSpaceOnUse",
    x1: -7863.2358,
    y1: 3018.104,
    x2: -7527.2344,
    y2: 2241.7361,
    gradientTransform: "matrix(-0.9994 0.0353 0.0353 0.9994 -5166.0664 63.2228)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000047040478001365095760000005267554140009490620_)"
    },
    d: "M2586.222,2839.605 c45.54-25.867,44.017-68.448,86.353-90.905c60-31.827,128.238,19.325,138.101,2.023 c10.25-17.978-70.572-61.116-61.464-113.281c7.231-41.41,62.778-39.748,90.642-97.893 c26.336-54.953-2.078-100.885,22.071-121.264c8.641-7.293,24.116-11.223,53.908,0.018 c-18.502,70.233-31.47,131.986-30.369,206.926c0.294,19.964,2.097,75.629,1.39,157.88 c-0.458,53.323-1.682,84.024-18.008,93.901c-17.063,10.322-37.145,1.649-79.816-8.513 c-31.493-7.5-57.595-15.952-119.556-2.212c-93.367,20.702-99.638,35.413-118.486,26.055 c-12.3-6.107-18.385-16.757-22.881-38.068C2547.161,2854.223,2567.208,2850.405,2586.222,2839.605z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088108547739881569140000001606160200503976117_",
    gradientUnits: "userSpaceOnUse",
    x1: 2889.0032,
    y1: 2595.717,
    x2: 2854.9031,
    y2: 2912.6458
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088108547739881569140000001606160200503976117_)"
    },
    d: "M2925.052,2621.259l-21.769,0.923 c0,0-24.503-18.916-35.362-16.485c-10.874,2.434-26.995,12.164-28.942,14.063c-1.948,1.898,6.315,10.578,14.265,8.839 c7.942-1.737,25.826,1.023,29.213,8.162c3.385,7.136,17.25,10.217,19.455,5.603l29.382,3.17L2925.052,2621.259z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052096851904467202820000018402002317898231486_",
    gradientUnits: "userSpaceOnUse",
    x1: -8167.8252,
    y1: 2866.7737,
    x2: -7841.7246,
    y2: 2113.2827,
    gradientTransform: "matrix(-0.9994 0.0353 0.0353 0.9994 -5166.0664 63.2228)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052096851904467202820000018402002317898231486_)"
    },
    d: "M2918.25,2613.803 c-0.97,19.213,3.285,31.754,10.012,39.95c29.742,36.243,125.68,9.98,180.892-48.038 c40.6-42.663,60.891-104.392,58.564-157.675c-4.543-104.018-96.752-199.194-232.693-224.553 c-18.318,66.17-36.682,132.504-55.091,199.006c84.144-6.067,120.458,55.12,114.344,104.013 C2989.72,2562.956,2967.946,2600.816,2918.25,2613.803z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000116954984929697565770000002898933202510824639_",
    d: "M3146.623,1123.34l-703.402-23.319l56.91,653.673 l69.18,0.538c26.222,95.74,104.373,164.813,195.63,164.455c90.079-0.353,165.389-68.379,190.29-161.456l138.472,19.089 L3146.623,1123.34z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038376761838189117490000018070361273677443969_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000116954984929697565770000002898933202510824639_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000038376761838189117490000018070361273677443969_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182509812272710023240000005126866671888850317_",
    gradientUnits: "userSpaceOnUse",
    x1: 6689.1436,
    y1: 1390.7729,
    x2: 6358.6074,
    y2: 1084.2758,
    gradientTransform: "matrix(0.9977 0.0671 -0.0671 0.9977 -3712.5464 -71.3376)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182509812272710023240000005126866671888850317_)"
    },
    d: "M2716.703,1319.844 c-34.49,9.318-78.834,48.817-102.123,70.599c-53.972,50.479-156.288,224.613-96.518,288.451 c40.411,43.161,110.942,25.924,141.841-16.545c22.651-31.131,8.941-59.95,4.171-116.656 C2658.939,1484.637,2680.677,1378.753,2716.703,1319.844z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109720755486604142810000004152758884973110951_",
    gradientUnits: "userSpaceOnUse",
    x1: 6688.3218,
    y1: 1660.8944,
    x2: 6468.7231,
    y2: 990.6387,
    gradientTransform: "matrix(0.9977 0.0671 -0.0671 0.9977 -3712.5464 -71.3376)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000109720755486604142810000004152758884973110951_)"
    },
    d: "M2687.653,1335.608 c-23.848,27.682-32.234,25.04-50.889,63.717c-28.188,58.442-7.418,126.62-4.462,199.565 c3.242,79.989,0.053,228.765-40.158,305.767c-0.703,1.344-1.046,1.626-1.016,3.636c1.235,81.735,378.578,22.855,377.993-6.291 c-2.901-144.768-95.605-464.333-72.54-569.039c-10.462-0.546-31.202-12.392-39.657-15.089 c-36.385-11.604-69.383-14.518-104.088-10.969c-12.734,1.302-19.15,4.035-28.464,7.319 C2709.219,1319.567,2699.43,1327.951,2687.653,1335.608z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152955963922832419860000000118993095785764245_",
    gradientUnits: "userSpaceOnUse",
    x1: -5269.9531,
    y1: 1278.8593,
    x2: -5207.6401,
    y2: 1278.8593,
    gradientTransform: "matrix(-1 0 0 1 -2436.8247 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152955963922832419860000000118993095785764245_)"
    },
    d: "M2822.406,1228.739 c-0.494,24.506,7.44,60.141,10.565,82.234c3.124,22.085-41.261,21.519-55.822,10.8c-13.395-9.86-3.31-34.984,9.598-47.873 C2799.634,1261.033,2809.285,1241.866,2822.406,1228.739z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135674078028214361780000001507084315899095172_",
    gradientUnits: "userSpaceOnUse",
    x1: 6335.0078,
    y1: 1117.8347,
    x2: 6434.2134,
    y2: 1407.9366,
    gradientTransform: "matrix(1 0 0 1 -3561.5725 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135674078028214361780000001507084315899095172_)"
    },
    d: "M2755.43,1218.334 c-20.637-19.233-24.429-84.657-3.505-96.456c10.127-5.71,27.755,27.21,39.203,33.914 c15.347,8.988,56.848,20.034,65.045,36.985c6.177,12.772-6.235,38.202-11.225,47.282 c-5.649,10.281-6.315,6.663-13.103,13.856c-9.422,9.983-21.992,21.628-31.588,32.893c-2.079-8.912-1.53-8.887-5.2-20.442 c-1.411-4.445-12.744-23.451-18.259-30.836C2773.293,1230.835,2757.955,1220.687,2755.43,1218.334z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126325018999268260510000016327222925451320481_",
    gradientUnits: "userSpaceOnUse",
    x1: -5232.4746,
    y1: 1203.5389,
    x2: -5223.2397,
    y2: 1441.1233,
    gradientTransform: "matrix(-1 0 0 1 -2436.8247 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126325018999268260510000016327222925451320481_)"
    },
    d: "M2821.243,1271.481 c-15.739,14.167-23.441,31.848-52.093,25.438c-25.741-5.758-30.065-70.877-6.638-89.071 c7.799-6.058,19.177-5.512,28.843-2.199c5.703,1.955,11.657,6.045,17.349,8.488c5.246,2.251,9.672-0.04,14.482,5.544 c6.014,6.982,1.933,24.005-1.515,32.178c2.636-2.242,5.605-5.43,9.057-6.383c2.433-0.672,6.658-4.602,8.951-0.964 c3.742,5.938-4.376,16.668-9.145,21.032C2828.35,1267.542,2823.915,1269.928,2821.243,1271.481z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138546229994984706250000007600713042424186027_",
    gradientUnits: "userSpaceOnUse",
    x1: 6311.9917,
    y1: 1130.4398,
    x2: 6408.5039,
    y2: 1412.6661,
    gradientTransform: "matrix(1 0 0 1 -3561.5725 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138546229994984706250000007600713042424186027_)"
    },
    d: "M2825.025,1215.623 c-3.497,1.904,2.724,8.7,1.791,15.137c-1.811,12.499-5.77,35.045-23.892,36.559c-10.734,0.897-21.996-9.239-33.281-10.837 c-6.995-0.99-14.72-0.905-21.691,0.723c-4.512,13.433-4.698,34.84,6.99,43.685c12.568,9.511,20.795,5.087,34.105,1.676 c8.894-2.279,18.698-9.694,24.278-18.31c5.81-8.971,10.071-18.455,15.827-27.895c3.176-5.21,7.021-11.736,10.758-17.18 c1.015-1.478,2.563-3.847,3.297-5.83C2840.209,1230.304,2830.082,1212.868,2825.025,1215.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2762.164,1267.05c5.305,3.192,11.523,3.401,17.286,3.7c0.28,0.014,1.523-0.435,1.045,0.607 c-1.797,3.917-9.597,5-13.56,3.699c-2.815-0.924-7.577-4.572-7.067-7.665 C2760.083,1266.086,2761.633,1267.306,2762.164,1267.05z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174590752890330348400000016505176881008283553_",
    gradientUnits: "userSpaceOnUse",
    x1: 6519.2485,
    y1: 1818.2207,
    x2: 6301.5674,
    y2: 1153.8196,
    gradientTransform: "matrix(0.9992 0.0409 -0.0409 0.9992 -3614.5337 -39.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000174590752890330348400000016505176881008283553_)"
    },
    d: "M2721.1,1805.555 c-10.215-11.658-26.484-30.225-27.45-56.056c-2.485-66.425,99.017-90.965,95.047-144.725 c-3.088-41.807-65.124-38.264-100.642-113.503c-6.115-12.952-28.525-62.245-12.266-116.953 c6.485-21.818,17.127-37.749,25.068-47.705c-4.387,2.962-8.647,6.032-13.205,8.994c-23.847,27.682-32.233,25.04-50.889,63.717 c-28.188,58.442-7.418,126.62-4.462,199.565c3.242,79.989,0.054,228.765-40.157,305.767c-0.703,1.344-1.174,2.217-1.017,3.636 c9.011,81.185,378.578,22.855,377.993-6.292c-0.35-17.451-2.006-37.426-4.593-59.218 C2951.71,1846.381,2793.847,1888.579,2721.1,1805.555z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052095024679550998200000001884129054763536574_",
    gradientUnits: "userSpaceOnUse",
    x1: 6653.7656,
    y1: 1398.4724,
    x2: 6347.5054,
    y2: 1114.4861,
    gradientTransform: "matrix(0.9977 0.0671 -0.0671 0.9977 -3712.5464 -71.3376)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052095024679550998200000001884129054763536574_)"
    },
    d: "M2613.556,1548.834 c-21.114-1.475-6.524-13.949-12.917-12.224c-4.006,1.082-102.65,96.016-71.434,147.512 c29.659,48.927,151.701,17.221,194.262,2.406c23.557-8.2,93.104-33.484,135.048-100.626c3.758-6.017,6.573-11.21,8.438-14.827 c-91.854-13.962-136.226-17.768-159.566-18.355C2692.378,1552.343,2677.209,1553.278,2613.556,1548.834z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057115136274080494020000006939827086808320443_",
    gradientUnits: "userSpaceOnUse",
    x1: 6650.8633,
    y1: 1677.8773,
    x2: 6675.5015,
    y2: 915.9964,
    gradientTransform: "matrix(0.9977 0.0671 -0.0671 0.9977 -3712.5464 -71.3376)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057115136274080494020000006939827086808320443_)"
    },
    d: "M2649.112,1539.782 c2.647,21.258,13.558,86.875,68.401,141.108c10.859,10.739,84.129,80.788,185.725,64.106 c78.484-12.887,147.718-73.301,163.634-149.214c30.978-147.752-154.836-285.128-198.138-263.89 c-29.203,14.323-37.558,123.165,6.156,179.289c9.469,12.156,27.042,29.095,24.322,49.832 c-2.613,19.918-22.483,32.182-33.76,38.929c-53.411,31.958-171.698-55.215-203.288-62.876 C2659.88,1536.948,2658.16,1534.74,2649.112,1539.782z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000923678238092493650000004941873512015714964_",
    gradientUnits: "userSpaceOnUse",
    x1: 6473.5015,
    y1: 1550.5336,
    x2: 6484.0347,
    y2: 1224.8119,
    gradientTransform: "matrix(0.9992 0.0409 -0.0409 0.9992 -3614.5337 -39.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000000923678238092493650000004941873512015714964_)"
    },
    d: "M2934.729,1511.82 c-18.24-19.278-39.424-29.729-63.316-37.791c-5.976-1.794-11.96-3.469-17.884-5.189c4.9,15.6,11.913,30.213,21.359,42.341 c9.469,12.156,27.043,29.095,24.322,49.832c-2.613,19.918-22.483,32.182-33.76,38.929 c-53.411,31.958-171.698-55.215-203.289-62.876c-2.283-0.118-4.003-2.325-13.051,2.717c0.664,5.331,1.848,13.455,4.118,23.494 c44.833-13.555,93.182,32.383,131.513,54.968c48.992,28.791,109.531,47.68,156.645,11.503 C2976.513,1603.399,2963.794,1543.344,2934.729,1511.82z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160908347308460622180000017187347632088480683_",
    gradientUnits: "userSpaceOnUse",
    x1: 6667.603,
    y1: 1703.5829,
    x2: 6686.8789,
    y2: 1107.509,
    gradientTransform: "matrix(0.9992 0.0409 -0.0409 0.9992 -3614.5337 -39.9982)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000160908347308460622180000017187347632088480683_)"
    },
    d: "M2957.745,1366.399 c-8.206,27.953-9.197,56.501,7.24,84.193c23.63,38.946,49.946,71.524,59.501,114.519c8.552,36.465,3.38,72.115-6.792,107.516 c-2.955,9.432-7.529,17.583-13.147,24.892c31.119-26.606,53.997-62.018,62.324-101.737 C3086.396,1502.662,3020.402,1414.236,2957.745,1366.399z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129927739661618062270000011052632716860539060_",
    gradientUnits: "userSpaceOnUse",
    x1: -5359.2598,
    y1: 1580.897,
    x2: -5295.3398,
    y2: 1580.897,
    gradientTransform: "matrix(-1 0 0 1 -2436.8247 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129927739661618062270000011052632716860539060_)"
    },
    d: "M2858.515,1585.903 c2.533,6.197,15.033,12.72,21.092,12.108c10.149-1.025,17.305-7.936,23.656-10.889c5.669-2.636,18.311-6.121,19.068-10.692 c1.434-8.655-12.374-11.363-20.486-12.356c-11.386-1.394-23.55,1.76-34.893,7.003 C2864.131,1576.064,2860.963,1580.951,2858.515,1585.903z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016770244771512528570000007273354323293122945_",
    gradientUnits: "userSpaceOnUse",
    x1: -5118.8452,
    y1: 1543.96,
    x2: -5067.1167,
    y2: 1543.96,
    gradientTransform: "matrix(-1 0 0 1 -2436.8247 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016770244771512528570000007273354323293122945_)"
    },
    d: "M2630.292,1549.952 c41.015,6.577,50.467,3.927,51.6,0.33c1.446-4.589-9.57-14.158-21.352-16.009 C2648.57,1532.392,2636.406,1538.572,2630.292,1549.952z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064317485759729216980000017931160571675633027_",
    gradientUnits: "userSpaceOnUse",
    x1: 8941.4551,
    y1: 1352.9624,
    x2: 8947.1299,
    y2: 1436.0942,
    gradientTransform: "matrix(0.9999 0.013 -0.013 0.9999 -6126.731 -191.3752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064317485759729216980000017931160571675633027_)"
    },
    d: "M2787.313,1326.587 c1.433,3.324,3.042,6.767,4.853,10.301c0.79,1.54,1.586,3.037,2.387,4.492c3.283,0.567,6.565,1.134,9.845,1.701 c2.097-4.771,4.194-9.542,6.291-14.311c-3.253,0.323-7.268,0.456-11.842,0.022 C2794.355,1328.365,2790.461,1327.5,2787.313,1326.587z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052814669192052208730000009311473910546774405_",
    gradientUnits: "userSpaceOnUse",
    x1: 8925.958,
    y1: 1522.8771,
    x2: 8925.958,
    y2: 1327.4052,
    gradientTransform: "matrix(0.9999 0.013 -0.013 0.9999 -6126.731 -191.3752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052814669192052208730000009311473910546774405_)"
    },
    d: "M2794.652,1340.456 c0,0-11.304,111.611-46.218,128.235c0.845,3.63-0.422,32.82-0.422,32.82s32.464-8.66,34.295-7.943 c1.831,0.716,39.767-60.171,22.093-150.487L2794.652,1340.456z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160880744833666923220000010119774584012402084_",
    gradientUnits: "userSpaceOnUse",
    x1: 1646.7522,
    y1: 1749.2063,
    x2: 4076.9226,
    y2: -1371.8893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160880744833666923220000010119774584012402084_)"
    },
    d: "M2519.268,691.798l-562.841-34.507 c-41.325-2.131-74.982,30.181-74.982,72.18v525.799c0,42,33.656,76.364,74.982,76.755l31.316,0.294V1461.8 c0,19.406,23.002,28.878,41.994,7.415l117.74-135.391l371.791,1.128c34.772,0.328,62.842-30.437,62.842-68.714V764.344 C2582.11,726.068,2554.04,693.591,2519.268,691.798z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151525187122369302150000014337199016946707129_",
    gradientUnits: "userSpaceOnUse",
    x1: 1877.2139,
    y1: 1462.4222,
    x2: 2317.4053,
    y2: 897.0795
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151525187122369302150000014337199016946707129_)"
    },
    d: "M2537.11,1321.241l-562.841-2.93 c-41.325-0.389-74.984-34.754-74.984-76.754V715.759c0-41.999,33.658-74.311,74.984-72.18l562.841,34.507 c34.772,1.793,62.84,34.27,62.84,72.547v501.894C2599.95,1290.804,2571.882,1321.568,2537.11,1321.241z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095314293575710984830000008180333149566619297_",
    gradientUnits: "userSpaceOnUse",
    x1: 2357.2451,
    y1: 1265.5999,
    x2: 2072.2961,
    y2: 540.8388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095314293575710984830000008180333149566619297_)"
    },
    d: "M1920.709,1255.707V702.916 c0-22.352,17.906-39.572,39.939-38.465l587.96,34.034c18.521,0.93,33.502,18.238,33.502,38.66v527.78 c0,20.424-14.981,36.818-33.503,36.619l-587.957-4.934C1938.616,1296.372,1920.709,1278.059,1920.709,1255.707z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053518793939147874020000000088244711840577701_",
    gradientUnits: "userSpaceOnUse",
    x1: 1915.3309,
    y1: 1526.0616,
    x2: 2532.2834,
    y2: 733.7024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FCB148"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0521,
    style: {
      stopColor: "#FDBA46"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1424,
    style: {
      stopColor: "#FFC244"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3183,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4849,
    style: {
      stopColor: "#FDB946"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#F99C4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8658,
    style: {
      stopColor: "#F8924F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8924F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053518793939147874020000000088244711840577701_)"
    },
    d: "M2005.583,1448.089v-156.117 l182.458,2.024l-146.26,168.09C2029.166,1476.585,2005.583,1467.494,2005.583,1448.089z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2155.489,989.479c0,23.461-19.741,42.042-44.177,41.498 c-24.53-0.545-44.485-20.141-44.485-43.766c0-23.625,19.955-42.2,44.485-41.49 C2135.748,946.428,2155.489,966.018,2155.489,989.479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2304.274,993.285c0,23.187-19.282,41.556-43.149,41.025 c-23.957-0.533-43.446-19.893-43.446-43.239c0-23.347,19.488-41.71,43.446-41.017 C2284.992,950.743,2304.274,970.098,2304.274,993.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2449.622,997.002c0,22.919-18.839,41.08-42.156,40.561 c-23.405-0.521-42.442-19.65-42.442-42.725c0-23.075,19.038-41.231,42.442-40.554 C2430.783,954.958,2449.622,974.083,2449.622,997.002z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.75
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145748134065194582970000004389031534673615010_",
    gradientUnits: "userSpaceOnUse",
    x1: 2587.3215,
    y1: 779.5401,
    x2: 2428.3521,
    y2: 1097.4785,
    gradientTransform: "matrix(0.9909 0.0176 0 1 7.5536 -14.8669)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145748134065194582970000004389031534673615010_)"
    },
    d: "M2989.436,785.719l-850.52-31.715 c-19.875-0.741-35.999,14.595-35.999,34.254v42.716c0,19.659,16.124,36.156,35.999,36.846l850.52,29.51 c19.095,0.663,34.562-14.404,34.562-33.651v-41.821C3023.998,802.611,3008.531,786.431,2989.436,785.719z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2998.329,874.724 2226.727,847.541 2226.727,780.605 2998.329,808.966  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2187.731,782.792c-9.825-12.898-28.07-15.853-40.752-6.589 c-12.69,9.269-14.998,27.253-5.152,40.158c9.094,11.919,25.36,15.301,37.776,8.432l21.319,27.961 c1.214,1.592,3.466,1.953,5.031,0.806c1.564-1.147,1.849-3.367,0.635-4.959l-21.313-27.96 C2195.509,810.929,2196.806,794.706,2187.731,782.792z M2180.106,819.657c-10.903,7.98-26.606,5.458-35.074-5.641 c-8.47-11.103-6.485-26.576,4.432-34.552c10.912-7.972,26.611-5.431,35.067,5.668 C2192.983,796.227,2191.003,811.681,2180.106,819.657z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavyTech);
export default __webpack_public_path__ + "static/media/Wavy_Tech.fa110634bfb7cc814fe1b794e42fb719.svg";
export { ForwardRef as ReactComponent };